import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ShopSelect from '../../components/tools/ShopSelect/ShopSelect';
import { setShowTools } from '../../actions/index';
import {
  selectShopAndConfig,
  selectSearchOrderShops,
  selectOrderingSystem,
} from '../../actions/tools/OrdersSearchActions';
import { setSearchType } from '../../actions/tools/ToolActions';
import {
  extractSelectedTicketBusinessDetailsFromState,
  getSimplrAccountIdOfSelectedTicket,
  extractSelectedTicketFromState,
} from '../../extractFromState';
import { loadShipstationShops } from '../../actions/tools/ShipstationActions';
import { getIsZendeskShopSelected } from '../../selectors/tools';

const mapStateToProps = (state) => ({
  simplrAccountId: getSimplrAccountIdOfSelectedTicket(state),
  shopifyConfigs: state.tools.general.selectedToolDomains.shopifyConfigs || {},
  general: (state.ui && state.ui.tools && state.ui.tools.general) || {},
  business: extractSelectedTicketBusinessDetailsFromState(state),
  ticket: extractSelectedTicketFromState(state) || {},
  isZendeskShopSelected: getIsZendeskShopSelected(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setShowTools,
      selectShopAndConfig,
      selectSearchOrderShops,
      selectOrderingSystem,
      setSearchType,
      loadShipstationShops,
    },
    dispatch
  );

const ShopSelectContainer = connect(mapStateToProps, mapDispatchToProps)(ShopSelect);

export default ShopSelectContainer;
